import { createSelector } from "@reduxjs/toolkit";
import { CargoScanReading } from "dora-contracts";
import { RootState } from "../../../redux-store";

const selectRoot = (state: RootState) => state.data.scanReadings;

const NO_READINGS: CargoScanReading[] = [];

export const selectScanReadings = (cargoId: string) =>
  createSelector(selectRoot, (s) => s.entities[cargoId] ?? NO_READINGS);

export const selectScanReadingsFailed = (cargoId: string) =>
  createSelector(selectRoot, (s) => s.requestStatus[cargoId] === "error");
